<template>
  <div class="chapter">
    <el-button @click="handleAdd">新增科目</el-button>

    <div class="dashboard-container">
      <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border
        lazy
        :indent="32"
        :default-expand-all="false"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column label="科目/章节" prop="name" align="left">
        </el-table-column>
        <el-table-column label="发布人" align="left">
          <template slot-scope="scope">{{ scope.row.user_name }}</template>
        </el-table-column>
        <el-table-column label="操作" align="left">
          <template slot-scope="scope" class="brief">
            <el-button
              v-if="scope.row.parent_id == 0"
              type="text"
              @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" v-else @click="handleEdit(scope.row)"
              >编辑章节</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.parent_id == 0"
              @click="creatChapter(scope.row.id)"
              >新增章节</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="addCourse"
      width="300px"
      center
      @close="handClose"
      :close-on-click-modal="false"
    >
      <el-input v-model="newCourse"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="createCourse" type="primary" @click="handleAddCourse"
          >立即创建</el-button
        >
        <el-button v-else type="primary" @click="handleAddCourse"
          >保存修改</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="chapterTitle"
      :visible.sync="addChapter"
      width="300px"
      center
      @close="toClose"
      :close-on-click-modal="false"
    >
      <el-input v-model="newChapter"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createChapter">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      chapterTitle: "",
      newCourse: "",
      newChapter: "",
      addCourse: false,
      addChapter: false,
      editChapter: false,
      createCourse: true,
      courseId: 0,
      chapterId: 0,
      tableData: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let _this = this;
      this.$http
        .get(process.env.VUE_APP_URL + "chapter")
        .then(function(data) {
          if (data.data.code == 200) {
            _this.tableData = data.data.data;
          } else {
            _this.$message.error(data.data.msg);
          }
        })
        .catch(function(error) {
          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    },
    handleAdd() {
      this.title = "新增科目";
      this.createCourse = true;
      this.addCourse = true;
    },
    edit(course) {
      this.title = "编辑科目";
      this.newCourse = course.name;
      this.courseId = course.id;
      this.createCourse = false;
      this.addCourse = true;
    },
    handleEdit(chapter) {
      this.chapterTitle = "编辑章节";
      this.editChapter = true;
      this.chapterId = chapter.id;
      this.newChapter = chapter.name;
      this.addChapter = true;
    },
    handleAddCourse() {
      let _this = this;
      this.addCourse = false;
      if (this.createCourse) {
        this.$http
          .post(process.env.VUE_APP_URL + "chapterInsert", {
            name: this.newCourse,
          })
          .then(function(data) {
            if (data.data.code == 200) {
              _this.$message.success("新增科目成功！");
              _this.newCourse = "";
              _this.init();
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch(function(error) {
            _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      } else {
        this.$http
          .post(process.env.VUE_APP_URL + "chapterUpdate", {
            id: this.courseId,
            name: this.newCourse,
          })
          .then(function(data) {
            if (data.data.code == 200) {
              _this.$message.success("修改科目成功！");
              _this.init();
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch(function(error) {
            _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      }
    },
    creatChapter(id) {
      this.chapterTitle = "新增章节";
      this.editChapter = false;
      this.addChapter = true;
      this.chapterId = id;
    },
    createChapter() {
      let _this = this;
      if (!this.editChapter) {
        this.$http
          .post(process.env.VUE_APP_URL + "chapterInsert", {
            id: this.chapterId,
            name: this.newChapter,
          })
          .then(function(data) {
            if (data.data.code == 200) {
              _this.$message.success("新增章节成功！");
              _this.addChapter = false;
              _this.newChapter = "";
              _this.init();
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch(function(error) {
            _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      } else {
        this.$http
          .post(process.env.VUE_APP_URL + "chapterUpdate", {
            id: this.chapterId,
            name: this.newChapter,
          })
          .then(function(data) {
            if (data.data.code == 200) {
              _this.$message.success("编辑章节成功！");
              _this.newChapter = "";
              _this.addChapter = false;
              _this.init();
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch(function(error) {
            _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      }
    },
    handClose() {
      console.log(1);
      this.newCourse = "";
    },
    toClose() {
      this.newChapter = "";
    },
  },
};
</script>

<style lang="less" scoped>
.chapter {
  text-align: left;
}
</style>
